import React from "react";

export const FAQS_DATA = () => {
  const selectedLanguage = localStorage.getItem("language");
  let faqs = [
    {
      id: "1",
      question: selectedLanguage === "arabic" ? "كيف يمكنني الاشتراك في الخدمات الإضافية؟" : "How can I subscribe to the add-on services?",
      answer: {
        title: selectedLanguage === "arabic" ? "يرجى تسجيل الدخول إلى المكتب الخلفي:" : "Please log in to the back office:",
        points: [
          {
            text: (
              <div className="pt-2">
                {selectedLanguage === "arabic" ? (
                  <>
                    من القائمة الجانبية إختر تبويبة <span style={{ fontWeight: 700 }}>الشركة.</span>
                  </>
                ) : (
                  <>
                    {" "}
                    From the sidebar, select the <span style={{ fontWeight: 700 }}>Company tab.</span>
                  </>
                )}
              </div>
            ),
          },
          {
            text: (
              <div>
                {selectedLanguage === "arabic" ? (
                  <>
                    {" "}
                    من التبويبة الفرعية إختر <span style={{ fontWeight: 700 }}>الإشتراكات</span>.
                  </>
                ) : (
                  <>
                    {" "}
                    Then choose <span style={{ fontWeight: 700 }}>Subscriptions</span> from the sub-menu.
                  </>
                )}
              </div>
            ),
          },
          {
            text: (
              <div>
                {selectedLanguage === "arabic" ? (
                  <>
                    أنقر زر <span style={{ fontWeight: 700 }}>الإشتراك</span> للخدمة التي ترغب الإشتراك فيها, علماً بأن لديك فرصة فترة تجريبية للخدمة
                    مجاناً لمدة 30 يوم.
                  </>
                ) : (
                  <>
                    {" "}
                    Click the <span style={{ fontWeight: 700 }}>Subscribe</span> button next to the service you wish to activate. Note: You are
                    entitled to a 30-day free trial for the selected service.
                  </>
                )}
              </div>
            ),
          },
        ],
      },
      isActive: false,
    },
    {
      id: "2",
      question: selectedLanguage === "arabic" ? "ما هي الفترة التجريبية وكيف تعمل؟" : "What is the trial period and how does it work?",
      answer: {
        title:
          selectedLanguage === "arabic" ? (
            <>
              <div>
                تتوفر فترة تجريبية <span style={{ fontWeight: 700 }}>مجانية لمدة 30 يومًا</span> لجميع الخدمات الإضافية، ولا يُطلب إدخال بطاقة ائتمان
                لبدئها.
              </div>
            </>
          ) : (
            <>
              <div>
                <span style={{ fontWeight: 700 }}>A 30-day free trial</span> is available for all add-on services, and no credit card is required to
                start it.
              </div>
            </>
          ),
        description: (
          <div>
            <div>
              {selectedLanguage === "arabic" ? (
                <>
                  <div>
                    بمجرد تفعيل الفترة التجريبية للخدمة، سيظهر تاريخ انتهائها في <span style={{ fontWeight: 700 }}>صفحة الاشتراكات</span>.
                  </div>
                </>
              ) : (
                <>
                  Once you activate the trial for a service, the trial end date will be displayed on the{" "}
                  <span style={{ fontWeight: 700 }}>Subscriptions page.</span>{" "}
                </>
              )}
            </div>
            <div className="py-2">
              {selectedLanguage === "arabic" ? (
                <>
                  <div>
                    إذا رغبت في الاستمرار باستخدام الخدمة بعد انتهاء الفترة التجريبية، يمكنك النقر على زر{" "}
                    <span style={{ fontWeight: 700 }}>إشتراك</span>. كما يمكنك إلغاء الاشتراك في أي وقت بالنقر على{" "}
                    <span style={{ fontWeight: 700 }}>إنهاء الاشتراك.</span>
                  </div>
                </>
              ) : (
                <>
                  If you wish to continue using the service after the trial ends, simply click the Subscribe button. You may also cancel your
                  subscription at any time by clicking <span style={{ fontWeight: 700 }}>Cancel Subscription.</span>
                </>
              )}
            </div>
            <div>
              {selectedLanguage === "arabic"
                ? " *يرجى ملاحظة أن الفترة التجريبية غير قابلة للإلغاء حتى في حال إلغاء الاشتراك قبل انتهائها."
                : "*Please note: The trial period cannot be canceled, even if you choose to unsubscribe before it ends."}
            </div>
          </div>
        ),
      },
      isActive: false,
    },
    {
      id: "3",
      question: selectedLanguage === "arabic" ? "كيف أقوم بالبدء بالاشتراك؟" : "How do I start a subscription?",
      answer: {
        description: (
          <div>
            <div>
              {selectedLanguage === "arabic" ? (
                <>
                  <span style={{ fontWeight: 700 }}>يمكنك بدء الاشتراك في أي وقت خلال أو بعد انتهاء الفترة التجريبية.</span> أثناء عملية البدء
                  بالإشتراك، سيُطلب منك إدخال تفاصيل بطاقة الدفع الخاصة بك.
                </>
              ) : (
                <>
                  <span style={{ fontWeight: 700 }}>You can start your subscription at any time during or after the free trial period.</span> During
                  the subscription process, you will be asked to enter your payment card details.
                </>
              )}
            </div>
            <div className="py-2">
              {selectedLanguage === "arabic" ? (
                <>
                  يرجى ملاحظة <span style={{ fontWeight: 700 }}>أن تكلفة إدارة الموظفين تُحسب لكل موظف.</span> إذا كنت قد أضفت موظفين للتجربة خلال
                  الفترة التجريبية المجانية ولا ترغب في دفع رسوم عنهم جميعًا، يُفضل تعديل عدد الموظفين وفق احتياجاتك قبل البدء بالاشتراك.
                </>
              ) : (
                <>
                  <span style={{ fontWeight: 700 }}> Please note that employee management is billed per employee. </span>If you've added employees
                  during the free trial but don't wish to be charged for all of them, it's recommended to adjust the number of employees based on your
                  needs before activating the subscription.
                </>
              )}
            </div>
            <div>
              {selectedLanguage === "arabic"
                ? "وإذا قمت بالبدء بالاشتراك قبل انتهاء الفترة التجريبية، فستبقى قادرًا على استخدام الخدمة مجانًا حتى نهاية الفترة، وسيتم خصم الرسوم تلقائيًا من بطاقتك وإصدار الفاتورة في تاريخ انتهاء الفترة التجريبية."
                : "If you start your subscription before the trial ends, you’ll still be able to use the service for free until the trial period expires, after which your card will be charged automatically and your invoice will be issued on the trial end date."}
            </div>
          </div>
        ),
      },
      isActive: false,
    },
    {
      id: "4",
      question: selectedLanguage === "arabic" ? "ما هي طرق الدفع المقبولة؟" : "What payment methods are accepted?",
      answer: {
        description: (
          <div>
            {selectedLanguage === "arabic" ? (
              <>
                نقبل حالياً <span style={{ fontWeight: 700 }}>الدفع بالريال السعودي</span>، عبر بطاقات الائتمان الرئيسية مثل:{" "}
                <span style={{ fontWeight: 700 }}>فيزا كارد, ماستر كارد و أمريكان إكسبريس.</span>
              </>
            ) : (
              <>
                We currently accept <span style={{ fontWeight: 700 }}>payments in Saudi Riyals (SAR)</span> using major credit cards, including{" "}
                <span style={{ fontWeight: 700 }}>Visa, MasterCard, and American Express.</span>
              </>
            )}
          </div>
        ),
      },
      isActive: false,
    },
    {
      id: "5",
      question: selectedLanguage === "arabic" ? "لماذا تم رفض بطاقة الدفع؟" : "Why was my payment card declined?",
      answer: {
        description: (
          <div>
            <div>
              {selectedLanguage === "arabic" ? (
                <>
                  {" "}
                  يُشير رفض البطاقة إلى أن البنك المُصدّر لبطاقة الدفع لم يتمكن من معالجة المعاملة.
                  <span style={{ fontWeight: 700 }}>
                    تجاوز حد الائتمان، أو الحظر بناءً على الموقع الجغرافي، أو رفض المعاملة بسبب سياسات الحماية من الاحتيال لدى البنك.
                  </span>
                </>
              ) : (
                <>
                  A declined transaction means that the issuing bank was unable to process the payment. Common reasons include{" "}
                  <span style={{ fontWeight: 700 }}>
                    Exceeding the credit limit, Geographic restrictions The bank's fraud protection policies blocking the transaction
                  </span>
                </>
              )}
            </div>
            <div className="py-2" style={{ fontWeight: selectedLanguage !== "arabic" && 700 }}>
              {selectedLanguage === "arabic" ? "ننصحك بالتواصل مع البنك لمزيد من التوضيح." : "We recommend contacting your bank for more details"}
            </div>
            <div>
              {selectedLanguage === "arabic"
                ? "عند الاتصال، جهّز معلومات مثل: قيمة المعاملة، اسم الموقع الإلكتروني الذي تم الدفع من خلاله، وتوقيت العملية، لتسهيل التحقق من سبب الرفض."
                : "When reaching out, have the following information ready to help them investigate Transaction amount, Name of the website used for payment, Time and date of the attempted transaction"}
            </div>
          </div>
        ),
      },
      isActive: false,
    },
    {
      id: "6",
      question:
        selectedLanguage === "arabic"
          ? "هل سأفقد بيانات المبيعات إذا تم حجب حسابي بسبب فشل الدفع؟"
          : "Will I lose my sales data if my account is suspended due to failed payment?",
      answer: {
        description: (
          <div>
            {selectedLanguage === "arabic" ? (
              <>
                <span style={{ fontWeight: 700 }}>لا، لن تفقد بيانات المبيعات في حال تم حجب المكتب الخلفي نتيجة فشل الدفع.</span>
                يظل النظام يحتفظ بجميع البيانات ويواصل رصد المبيعات بشكل طبيعي. بمجرد إتمام عملية الدفع ورفع الحجب، سيتم عرض أحدث بيانات المبيعات في
                المكتب الخلفي بشكل فوري.
              </>
            ) : (
              <>
                <div style={{ fontWeight: 700 }}>
                  {" "}
                  No, your sales data will not be lost if your back office is suspended due to a failed payment. The system will continue to track and
                  store all sales data as usual.
                </div>
              </>
            )}

            <div className="pt-2">
              {selectedLanguage === "arabic"
                ? // ? "بمجرد إتمام عملية الدفع ورفع الحجب، سيتم عرض أحدث بيانات المبيعات في المكتب الخلفي بشكل فوري."
                  ""
                : "Once the payment is completed and access is restored, the latest sales data will be instantly available in your back office."}
            </div>
          </div>
        ),
      },
      isActive: false,
    },
    {
      id: "7",
      question: selectedLanguage === "arabic" ? "كيف يمكنني إلغاء اشتراكي؟" : "How can I cancel my subscription?",
      answer: {
        title: (
          <div>
            {selectedLanguage === "arabic" ? (
              <>
                يتم تجديد الاشتراك تلقائيًا في نهاية كل دورة فوترة، لكن <span className="fw-bold">يمكنك إلغاؤه بسهولة</span> في أي وقت باتباع الخطوات
                التالية:
              </>
            ) : (
              <>
                Subscriptions are automatically renewed at the end of each billing cycle. However,{" "}
                <span style={{ fontWeight: 700 }}>you can cancel your subscription at any time</span> by following these steps:
              </>
            )}
          </div>
        ),
        points: [
          {
            text: (
              <div>
                {selectedLanguage === "arabic" ? (
                  <>
                    <span className="fw-bold">سجّل الدخول إلى المكتب الخلفي</span> باستخدام البريد الإلكتروني الخاص بالمالك.
                  </>
                ) : (
                  <>
                    <span style={{ fontWeight: 700 }}>Log in to the back office</span> using the owner’s email address.
                  </>
                )}
              </div>
            ),
          },
          {
            text: (
              <div>
                {selectedLanguage === "arabic" ? (
                  <>
                    انتقل إلى <span className="fw-bold">الشركة</span>، ثم اختر <span className="fw-bold">الاشتراكات</span>.
                  </>
                ) : (
                  <>
                    Go to the <span style={{ fontWeight: 700 }}>Company</span> tab, then select{" "}
                    <span style={{ fontWeight: 700 }}>Subscriptions.</span>{" "}
                  </>
                )}
              </div>
            ),
          },
          {
            text: (
              <div>
                {selectedLanguage === "arabic" ? (
                  <>
                    انقر على زر <span style={{ fontWeight: 700 }}>إلغاء الاشتراك</span> بجانب الاشتراك النشط.
                  </>
                ) : (
                  <>
                    Click the <span style={{ fontWeight: 700 }}>Cancel Subscription</span> button next to the active subscription.{" "}
                  </>
                )}
              </div>
            ),
          },
        ],
        description: (
          <div>
            {selectedLanguage === "arabic" ? (
              <>
                *يرجى ملاحظة أنه <span style={{ fontWeight: 700 }}>في حال إلغاء الاشتراك فإن النظام سيقوم بحذف جميع المستخدمين</span> ماعدا المالك.
              </>
            ) : (
              <>
                *Please note <span style={{ fontWeight: 700 }}>Upon cancellation, the system will automatically remove all users</span> except the
                account owner.
              </>
            )}
          </div>
        ),
      },

      isActive: false,
    },
    {
      id: "8",
      question:
        selectedLanguage === "arabic"
          ? `إذا توقفت عن استخدام خدمات "فاتورتي" أو الخدمات الإضافية دون أن أقوم بإلغاء الإشتراك، هل سيستمر السحب من بطاقتي؟`
          : "If I stop using Fatooraty or the add-on services without canceling my subscription, will I still be charged?",
      answer: {
        description: (
          <div>
            <div>
              {selectedLanguage === "arabic" ? (
                <>
                  {" "}
                  <span style={{ fontWeight: 700 }}>نعم، طالما أن الاشتراك لا يزال نشطًا،</span> فستستمر الرسوم بالسحب من بطاقتك حتى وإن لم تكن تستخدم
                  الخدمات الإضافية أو تطبيق فاتورتي.
                </>
              ) : (
                <>
                  <span style={{ fontWeight: 700 }}>Yes, as long as your subscription remains active,</span> charges will continue to be deducted from
                  your payment card—even if you're not using Fatooraty or any add-on services.
                </>
              )}
            </div>
            <div className="py-2" style={{ fontWeight: 700 }}>
              {selectedLanguage === "arabic"
                ? ` إذا قررت التوقف عن استخدام الخدمة، يُرجى إلغاء الاشتراك من صفحة "الاشتراكات" في المكتب الخلفي لتجنب السحب التلقائي.`
                : `If you decide to stop using the service, please make sure to cancel your subscription from the Subscriptions page in the back office to
            avoid automatic charges.`}
            </div>
            <div>
              {selectedLanguage === "arabic"
                ? "*يرجى ملاحظة أننا لا نقدم استردادًا للمبالغ المدفوعة، لكنها ستبقى في محفظة حسابك ويمكنك إستخدمها في وقت لاحق."
                : "*Please note: We do not offer refunds for paid amounts. However, the balance will remain in your account wallet and can be used later."}
            </div>
          </div>
        ),
      },
      isActive: false,
    },
    {
      id: "9",
      question:
        selectedLanguage === "arabic"
          ? "هل يمكنني إيقاف المدفوعات المتكررة أو حذف تفاصيل بطاقتي؟"
          : "Can I stop recurring payments or remove my card details?",
      answer: {
        description: (
          <div>
            <div>
              {selectedLanguage === "arabic" ? (
                <>
                  {" "}
                  نعم، يمكنك ذلك عن طريق إرسال طلب عبر البريد الإلكتروني إلى <span style={{ fontWeight: 700 }}>help@fatoraty.com</span> باستخدام عنوان
                  البريد الإلكتروني المرتبط بحساب منشأتك.
                </>
              ) : (
                <>
                  Yes, you can. Simply send a request to <span style={{ fontWeight: 700 }}>help@fatoraty.com</span> using the email address associated
                  with your company account.
                </>
              )}
            </div>
            <div className="pt-2">
              {selectedLanguage === "arabic"
                ? "يرجى ذكر رغبتك في إيقاف المدفوعات المتكررة أو حذف تفاصيل البطاقة بشكل واضح ضمن الرسالة ليتم تنفيذ الطلب بأسرع وقت ممكن."
                : "Please clearly state your request to stop recurring payments or remove your card details in the message so we can process it as quickly as possible."}
            </div>
          </div>
        ),
      },
      isActive: false,
    },
  ];
  return faqs;
};
